export const cooKeys = {
  visited_feature: "visited-feature",
  goi_member_id: "goi-member-id",
  goi_action: "goi-action",
  quotation_request: "quotation-request",
  quotation_request_CRM_tried: "quotationRequestCRMTried",
  quotation_request_facility: "facility-quotation-request",
  estimate_key: "estimate_key",
  block_banner: "block_banner",
  kakao_redirect: "kakao-redirect",
  kakao_auto_login_handled: "isKakaoAutoLoginHandled",
  previous: "previous",
  event_from: "event-from",
  first_visit_date: "first_visit_date",
  first_visit_parlor: "first_visit_parlor",
  goi_admin_refresh_token:
    process.env.NEXT_PUBLIC_IS_PRODUCTION === "true"
      ? "goi_admin_refresh_token"
      : "goi_admin_dev_refresh_token",
  session_landing_type: "session-landing-type",
  is_search_ad: "is_search_ad",
  goi_fp_id: "goi_fp_id",
  parlor_request_info: "parlor-request-info",
  cost_comparison_entry: "cost-comparison-entry",
  brand_search_ad_entry: "brand-search-ad-entry",
};
